import { PlannerProfileListSearchCriteria } from '../../../../models';

export class TransportPlannerProfileListLoad {
  public static readonly type = '[TransportPlannerProfileList] Load';
  constructor(public payload: PlannerProfileListSearchCriteria) {}
}

export class TransportPlannerProfileListInitialState {
  public static readonly type = '[TransportPlannerProfileList] Set Initial State';
}
